export default "__VITE_ASSET__CraiFK1M__"